import { put, takeEvery, call } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { FetchMCOnboardings, FetchMCOnboardingsCounts } from 'src/constants/actionTypes'
import { Endpoints } from 'src/constants/endpoints'
import { ApiService, callSecureApi } from '../api/callApi'
import { Pagination } from 'src/interfaces/table'
import { MCOnboarding, MCOnboardingCounts } from 'src/interfaces/mcOnboarding'
import { MCStatus } from 'src/constants/mc/enums'

export interface FetchMCOnboardingsPayload {
  status?: MCStatus
  search?: string
  tags?: string[]
}

function* onFetchMCOnboardings(
  action: AsyncAction<
    FetchMCOnboardingsPayload,
    { data: Array<MCOnboarding>; pagination: Pagination }
  >,
) {
  const { status, search, tags } = action.payload

  try {
    const { payload }: { payload: Array<MCOnboarding> } = yield call(
      callSecureApi,
      Endpoints.FetchMCOnboardings,
      {
        apiService: ApiService.Paraworks,
        query: {
          status,
          search,
          tags,
        },
      },
    )

    const res = {
      data: payload,
      pagination: {
        total: payload.length,
        limit: payload.length,
        offset: 0,
      },
    }

    yield put(FetchMCOnboardings.success(res))

    if (action.next) {
      action.next(null, res)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to fetch onboardings'

    yield put(FetchMCOnboardings.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

function* onFetchMCOnboardingsCounts(action: AsyncAction<void, MCOnboardingCounts>) {
  try {
    const { payload }: { payload: MCOnboardingCounts } = yield call(
      callSecureApi,
      Endpoints.FetchMCOnboardingsCounts,
      {
        apiService: ApiService.Paraworks,
      },
    )

    yield put(FetchMCOnboardingsCounts.success(payload))

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to fetch onboardings counts'

    yield put(FetchMCOnboardingsCounts.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* sharedMCOnboardingSaga() {
  yield takeEvery(FetchMCOnboardings.type.REQUEST, onFetchMCOnboardings)
  yield takeEvery(FetchMCOnboardingsCounts.type.REQUEST, onFetchMCOnboardingsCounts)
}
